import React, {useContext, useEffect, useState} from "react";
import '../../../styles/pages/Vulnerabilities2/Vulnerabilities/ExpandedView.scss';
import Tab from "../../../components/Tab/Tab";
import {actionOptions, tableHeaders, tables, tabs} from "../config/vulnerabilitytabconfig";
import {Pagination} from "../../../components";
import {getVulnerabilitiesExpandedData, postUpdateActionOrComment} from "../../../api/ApiClient";
import {captureSentryError} from "../../../util/sentry";
import UserData from "../../../store/User/UserData";
import {Loader} from "../../../components/Loader/Loader";
import {ExpandedViewTable} from "./ExpandedViewTable";
import Dropdown from "../../../components/Dropdown/Dropdown";
import ActionModal from "../ActionModal";
import {ExpandedTableList} from "../ExpandedTable";
import CommentModal from "../CommentModal";

const ExpandedView = ({data, index, setParentTab, action}) => {
    const [userData,] = useContext(UserData);
    const [currTab, setCurrTab] = useState('affected-assets');
    const [page, setPage] = useState(1);
    const [loading, setIsLoading] = useState(true)
    const [tableData, setTableData] = useState({})
    const [loadingTable, setLoadingTable] = useState(false)
    const [selectedGlobalAction, setSelectedGlobalAction] = useState('Global Actions')
    const [openDropdown, setOpenDropdown] = useState(false);
    const [selectAllCheckboxes, setSelectAllCheckboxes] = useState(false);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [loadingActionUpdate, setLoadingActionUpdate] = useState(false);
    const [params, setParams] = useState({page: page, size: 25, sort_by: 'ipaddress', order: 'desc'})
    const [globalComment, setGlobalComment] = useState('')
    const [loadingGlobalComments, setLoadingGlobalComments] = useState(false)
    const [openCommentModal, setOpenCommentModal] = useState(false)

    const selectActionFromDropdown = (value) => {
      setSelectedGlobalAction(value);
      setOpenDropdown(false);
      if (value.includes('Comments')) setOpenCommentModal(true)
    };

    const getData = async (onPageChange) => {
      setIsLoading(onPageChange !== true);
      if (onPageChange === true) {
        setLoadingTable(true);
      }
      try {
        let newParams = {...params, page: page}
        if (action) newParams.action = action
        if (newParams.sort_by === 'action_taken') newParams.sort_by = 'action'
        let response = await getVulnerabilitiesExpandedData(userData.tenant, data.vulnerability_id, newParams);
        setTableData(response)
      } catch (e) {
        captureSentryError(e, userData, 'getVulnerabilitiesTable')
      } finally {
        setIsLoading(false)
        setLoadingTable(false)
        setSelectAllCheckboxes(false)
        setOpenCommentModal(false)
      }
    }

    useEffect(() => {
      (userData.tenant && loading === true) ? getData() : getData(true)
      // eslint-disable-next-line
    }, [userData.tenant, page, params]);

    const sortTable = (value) => {
      const newParams = {
        ...params,
        sort_by: value,
        order: params.sort_by === value && params.order === 'asc' ? 'desc' : 'asc',
      };
      setParams(newParams);
    };

    const submitGlobalComment = async (value) => {
      setLoadingGlobalComments(true);
      try {
        const vuln_id = data?.vulnerability_id || ''
        let body = {asset_names: selectedCheckboxes}
        if (value.length > 0) body.comment = value
        if (selectedGlobalAction !== 'Global Actions' && !selectedGlobalAction.includes('Comments')) body.action = selectedGlobalAction
        await postUpdateActionOrComment(userData?.tenant, vuln_id, body);
      } catch (e) {
        captureSentryError(e, userData, "postUpdateActionOrComment add global comment");
      } finally {
        setLoadingGlobalComments(false);
        setSelectedGlobalAction('Global Actions')
        await getData(true)
      }
    };

    return (
      <div className={"flex expanded-container"} key={index}>
        {loading ? <Loader/> :
          <>
            <div className={"vulnerability-data-table"}>
              {tables.map((table, index) =>
                <ExpandedTableList key={index} data={tableData?.details} labels={table?.labels} title={table?.title}/>
              )}
            </div>
            {selectedGlobalAction !== 'Global Actions' && (!openCommentModal ?
              <ActionModal
                count={selectedCheckboxes.length}
                setSelectedGlobalAction={setSelectedGlobalAction}
                className={"update-action-modal"}
                setLoadingActionUpdate={setLoadingActionUpdate}
                loadingActionUpdate={loadingActionUpdate}
                setOpenCommentModal={setOpenCommentModal}
              /> : <CommentModal
                existingComment={tableData?.affected_assets?.results
                  .filter(item => (item.hostname || item.ipaddress) === selectedCheckboxes[0])[0].comment || ''}
                selectedCheckboxes={selectedCheckboxes}
                type={selectedGlobalAction}
                setSelectedGlobalAction={setSelectedGlobalAction}
                cancel={() => {setSelectedGlobalAction('Global Actions');setOpenCommentModal(false)}}
                setGlobalComment={setGlobalComment}
                globalComment={globalComment}
                submit={submitGlobalComment}
                loading={loadingGlobalComments}
                setOpenCommentModal={setOpenCommentModal}
              />)}
            <div className={"assets-and-details"}>
              <div className={"tab-container"}>
                {tabs.map((tab) => (
                  <Tab
                    onClick={() => setCurrTab(tab.configName)}
                    key={tab.configName}
                    data={tab}
                    selected={tab.configName === currTab}
                  />
                ))}
              </div>
              <div className={"table-container"}>
                {loadingTable ? <Loader/> : <>
                  <div className={"flex assets-pagination"}>
                    <p className={"results"}>{tableData?.affected_assets?.total.toString() + ' Results'}</p>
                    {tableData?.affected_assets?.total > 25 && <Pagination
                      setPage={setPage}
                      page={page}
                      total={tableData?.affected_assets?.total}
                      pageSize={25}
                    />}
                    <Dropdown
                      className={"global-action-dropdown " +
                      (selectedCheckboxes.length === 0 && !selectAllCheckboxes ? "disabled" : "")
                      }
                      name={"Global Actions"}
                      dropdownList={actionOptions}
                      selectItem={(value) =>
                        (selectedCheckboxes.length === 0 && !selectAllCheckboxes) ? null : selectActionFromDropdown(value)
                      }
                      selectedItem={selectedGlobalAction}
                      showDropdown={openDropdown === true}
                      setShowDropdown={setOpenDropdown}
                    />
                  </div>
                  <ExpandedViewTable
                    page={"vulnerabilities"}
                    className={"vulnerabilities"}
                    headers={tableHeaders}
                    data={tableData?.affected_assets?.results}
                    vuln_id={data?.vulnerability_id || ''}
                    selectAllCheckboxes={selectAllCheckboxes}
                    setSelectAllCheckboxes={setSelectAllCheckboxes}
                    selectedCheckboxes={selectedCheckboxes}
                    setSelectedCheckboxes={setSelectedCheckboxes}
                    setParentTab={setParentTab}
                    sortTable={sortTable}
                    params={params}
                  />
                  {tableData?.affected_assets?.total > 25 && <Pagination
                    setPage={setPage}
                    page={page}
                    total={tableData?.affected_assets?.total}
                    pageSize={25}
                  />}</>}
              </div>
            </div>
          </>}
      </div>
    );
  }
;

export default ExpandedView;
